import { render } from "./DropDownMiltiple.vue?vue&type=template&id=12b1b0bb&scoped=true&ts=true&lang=pug"
import script from "./DropDownMiltiple.vue?vue&type=script&lang=ts&setup=true"
export * from "./DropDownMiltiple.vue?vue&type=script&lang=ts&setup=true"

import "./DropDownMiltiple.vue?vue&type=style&index=0&id=12b1b0bb&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12b1b0bb"]])

export default __exports__